import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as topicsKeys } from "../../topics/api/keys";
import { keys as remindersKeys } from "./keys";

type Command = Database['public']['Tables']['reminders']['Insert'];

async function postReminder(reminder: Command) {
  const { data, error } = await apiClient
    .from('reminders')
    .insert([reminder])
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export default function usePostReminder() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (command: Omit<Command, 'space_id'>) => postReminder({ ...command, space_id: currentSpace!.id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: remindersKeys.lists() });
      queryClient.invalidateQueries({ queryKey: remindersKeys.upcomingAll() });
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: topicsKeys.pendingSubTopics(currentSpace.id) });
      }
    },
  });
}
